import { GetCurrentPlateformeResponse } from "api/plateforme"
import { Dispatch } from "react"
import { AppInitAction, AppInitSyncActions, SwitchPlateformeData } from "./types"

const createSyncActions = (dispatch: Dispatch<AppInitAction>): AppInitSyncActions => ({
  setLoading: (loading: boolean) => {
    dispatch({ type: 'SET_LOADING', payload: loading })
  },
  setError: (error: string | null) => {
    dispatch({ type: 'SET_ERROR', payload: error })
  },
  setInitialized: (initialized: boolean) => {
    dispatch({ type: 'SET_INITIALIZED', payload: initialized })
  },
  setPlateformeData: (data: GetCurrentPlateformeResponse) => {
    dispatch({ type: 'SET_ORGANIZATION_DATA', payload: data })
  },
  switchPlateformeData: (data: SwitchPlateformeData) => {
    dispatch({ type: 'SWITCH_ORGANIZATION', payload: data })
  },
  reset: () => {
    dispatch({ type: 'RESET' })
  }
})

export default createSyncActions
